import { ContactsContext } from 'contexts/ContactsContext';
import { useContext } from 'react';

// ----------------------------------------------------------------------

const useContacts = () => useContext(ContactsContext);

export default useContacts;
